import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowCircleRight } from 'react-icons/fa'; 
import marketingHeroImg from "../assets/headerImg.png"; // Replace with your final cropped asset path
import Aos from 'aos';
import 'aos/dist/aos.css';
import { authService } from '../Components/services/auth';

const Header = ({ handleBookDemo, handleContactSpecialist }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    Aos.init({ duration: 1000 });
    // Check if user is logged in
    const user = authService.getCurrentUser();
    setCurrentUser(user);
  }, []);

  const handleAdminDashboard = () => {
    if (currentUser) {
      navigate('/admin');
    } else {
      navigate('/login');
    }
  };

  const handleLogout = () => {
    authService.logout();
    setCurrentUser(null);
    window.location.reload(); // Refresh to update UI
  };

  return (
    <div 
      className='w-full min-h-screen lg:h-screen bg-gradient-to-r from-[#21810c] via-[#3ca615] to-[#61e02f] pl-6 pr-6 sm:pl-10 sm:pr-10 md:pl-16 md:pr-16 lg:pl-24 lg:pr-24 xl:pl-32 xl:pr-32 flex flex-col lg:flex-row items-center justify-between gap-10 relative overflow-hidden font-sans' 
      data-aos="fade-up" 
      data-aos-offset="50"
    >
      
      {/* Admin Navigation Layer */}
      <div className="absolute top-6 right-6 z-50">
        {currentUser ? (
          <div className="flex items-center gap-4 bg-black/20 p-2 rounded-xl backdrop-blur-sm">
            <span className="text-white text-sm font-medium px-3 py-1">
              Welcome, {currentUser.fullName}
            </span>
            <button
              onClick={() => navigate('/admin')}
              className="bg-white text-[#21810c] font-semibold px-4 py-2 rounded-full hover:bg-opacity-90 transition text-sm shadow"
            >
              Dashboard
            </button>
            <button
              onClick={handleLogout}
              className="bg-red-600 text-white px-4 py-2 rounded-full hover:bg-red-700 transition text-sm font-medium shadow"
            >
              Logout
            </button>
          </div>
        ) : (
          <button
            onClick={handleAdminDashboard}
            className="bg-[#0b0080] text-white px-6 py-2.5 rounded-full hover:bg-opacity-90 transition text-sm font-bold tracking-wide shadow-lg"
          >
            Admin Login
          </button>
        )}
      </div>

      {/* Left Text & Actions Content */}
      <div className='flex flex-col gap-6 max-w-[650px] pt-28 lg:pt-0 z-10'>
        {/* Content precisely mapped from Figma layout */}
        <h1 className='text-4xl sm:text-5xl md:text-[56px] text-white font-semibold leading-[1.1] tracking-tight'>
          Data breaches?<br />
          Cyberattacks?<br />
          Unauthorized access?
        </h1>
        
        <p className='text-white text-lg md:text-[22px] font-normal leading-relaxed opacity-95'>
          With <span className='font-bold'>Andurar Cloud</span>, your data doesn't just sit there, it's protected.
        </p>

        {/* Buttons Grouping */}
        <div className='flex flex-col sm:flex-row gap-4 mt-4 items-stretch sm:items-center'>
          {/* Main Book Demo Button styled to mirror the dark Figma "Explore More" button */}
          <button
            className='h-14 px-8 text-base bg-[#0b0080] rounded-full text-white font-semibold flex items-center justify-center gap-3 shadow-lg hover:bg-opacity-90 transition transform active:scale-95'
            onClick={handleBookDemo}
          >
            Book a Demo
            <FaArrowCircleRight className="text-xl" />
          </button>

          {/* High-Contrast Visible Subscribe Button */}
          <button 
            className='text-white h-14 px-8 rounded-full border border-white/50 text-base font-semibold bg-white/20 backdrop-blur-md hover:bg-white hover:text-[#21810c] transition transform active:scale-95 shadow-sm' 
            onClick={handleContactSpecialist}
          >
            Subscribe
          </button>
        </div>
      </div>

      {/* Right Graphics Container with Radial Light Circling Aura */}
      <div className='w-full lg:w-1/2 flex items-end justify-center lg:justify-end h-full relative lg:absolute lg:right-0 lg:bottom-0 z-0'>
        
        {/* The Lighter Circling Highlight Layer backing the asset image */}
        <div className="absolute w-[500px] h-[500px] md:w-[700px] md:h-[700px] rounded-full bg-[radial-gradient(circle,_rgba(255,255,255,0.45)_0%,_rgba(255,255,255,0)_65%)] bottom-[10%] lg:bottom-[5%] right-1/2 translate-x-1/2 lg:translate-x-0 lg:right-[5%] pointer-events-none mix-blend-screen" />
        
        {/* Main Character Asset */}
        <img 
          src={marketingHeroImg} 
          alt="Andurar Protected Cloud" 
          className="max-h-[55vh] lg:max-h-[92vh] w-auto object-contain object-bottom select-none pointer-events-none z-10 relative"
        />
      </div>

      {/* Carousel Pagination UI Overlays */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2 z-10">
        <span className="w-2.5 h-2.5 rounded-full bg-white opacity-100"></span>
        <span className="w-2.5 h-2.5 rounded-full bg-white opacity-60"></span>
        <span className="w-2.5 h-2.5 rounded-full bg-white opacity-60"></span>
      </div>

    </div>
  );
};

export default Header;